import React, { useState, useEffect } from "react";
import images from "../../../ressources/images";
import { withTranslation } from "react-i18next";
import InputRange from "react-input-range-rtl";
import { setFilter } from "../../../api/shop";
import InsButton from "../../InsButton/InsButton";
import InsLoader from "../../InsLoader/InsLoader";
// import 'react-input-range/lib/css/index.css'

function ShopFilter(props) {
  const [selectFilter, setSelectFilter] = useState("points");
  const [pointsValue, setPointsValue] = useState({ min: 1, max: 2000 });
  const [category, setCategory] = useState("");
  const [errorFilter, setErrorFilter] = useState(false);
  const [contentHeight, setContentHeight] = useState(window.innerHeight);
  const { categories, loader, t, offset } = props;

  const chooseFilter = (value) => {
    setSelectFilter(value);
  };

  const updateDimensions = () => {
    setContentHeight(window.innerHeight);
  };

  const selectCat = (name) => {
    setCategory(name);
  };

  const submitFilter = () => {
    let obj = {};
    obj.min = pointsValue.min;
    obj.max = pointsValue.max;
    if (category) {
      obj.category = category;
    }
    setFilter({ ...obj, offset }).then((data) => {
      if (data.gifts.length > 0) {
        props.updatedProducts(data, obj);
      } else {
        setErrorFilter(true);
        resetFilter();
      }
    });
  };

  const resetFilter = () => {
    let catRadio = document.getElementsByName("category");
    for (let i = 0; i < catRadio.length; i++) {
      if (catRadio[i].checked) {
        catRadio[i].checked = false;
      }
    }
    setCategory("");
    setPointsValue({ min: 1, max: 2000 });
    props.resetFilters();
  };

  const onChangePoints = (value) => {
    if (value.min < 1) {
      value.min = 1;
    }
    if (value.max > 2000) {
      value.max = 2000;
    }
    setPointsValue(value);
  };

  useEffect(() => {
    window.addEventListener("resize", updateDimensions);
  }, []);

  let contentStyle = { height: contentHeight - 120 };

  return loader ? (
    <InsLoader />
  ) : (
    <div className={props.className} style={contentStyle}>
      <div className="header_filter">
        <div className="title">{t("filter")}</div>
        <div className="close_filter" onClick={props.filter}>
          <img src={images.closeCross} alt="" />
        </div>
      </div>
      <div className="select_filter">
        <div
          className={
            selectFilter === "points"
              ? "select_points selected"
              : "select_points"
          }
          onClick={() => chooseFilter("points")}
        >
          {t("points")}
        </div>
        <div
          className={
            selectFilter === "cat" ? "select_cat selected" : "select_cat"
          }
          onClick={() => chooseFilter("cat")}
        >
          {t("categories")}
        </div>
      </div>
      <div className="filter_container">
        <div
          className={
            selectFilter === "points" ? "filter_points show" : "filter_points"
          }
        >
          <div className="range_selector">
            <div className="range">
              <div className="min">1 pts</div>
              <div className="max">2000 pts</div>
            </div>
            <InputRange
              minValue={1}
              maxValue={2000}
              value={pointsValue}
              onChange={(value) => onChangePoints(value)}
              direction={
                document.body.classList.contains("rtl") ? "rtl" : "ltr"
              }
            />
          </div>

          <div className="range_select">
            <span className="min">{pointsValue.min}</span>
            {t("to")}
            <span className="max">{pointsValue.max}</span>
            points
          </div>
        </div>
        <div
          className={selectFilter === "cat" ? "filter_cat show" : "filter_cat"}
        >
          {categories &&
            categories.categories &&
            categories.categories.length &&
            categories.categories.map((category) => (
              <div key={category.id} className="category_wrapper">
                <input
                  type="radio"
                  id={category.name}
                  name="category"
                  className="category"
                />
                <label
                  htmlFor={category.name}
                  onClick={() => selectCat(category.name)}
                >
                  {category.name}
                </label>
              </div>
            ))}
        </div>
        <div className="btn_wrapper">
          {errorFilter && (
            <div className="error_filter">{t("error_filter_shop")}</div>
          )}
          <InsButton text={t("validate")} onClick={submitFilter} />
        </div>
        <p className="reset_filter" onClick={resetFilter}>
          {t("reset_filter")}
        </p>
      </div>
    </div>
  );
}

export default withTranslation()(ShopFilter);
